import React from 'react';

import styles from './PersonalStatementLoader.module.scss';
import { ReactComponent as Robot } from 'assets/profile/happy_robot.svg';

const PersonalStatementLoader = (): React.ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <Robot />
      </div>
      <div className={styles.text}>
        Hold tight~ Your personal statement is in the works! Just a few more seconds... and it will
        be ready to shine!
      </div>
    </div>
  );
};

export default PersonalStatementLoader;
